import React, {Component} from 'react';
import './chatLandingCarousel.scss';
import {withStyles} from '@material-ui/core/styles';
import compose from 'recompose/compose';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Grid from "@material-ui/core/Grid";
import Hidden from '@material-ui/core/Hidden';
import Link from "@material-ui/core/Link";
import withWidth from '@material-ui/core/withWidth';
import {isBrowser} from "react-device-detect";
import classNames from 'classnames';
import carouselConfig from './carouselConfig';

import CarouselHoverLeftImage from '../../../public/images/carousel-hover-left.svg';
import CarouselHoverRightImage from '../../../public/images/carousel-hover-right.svg';
import CarouselSwipeLeftImage from '../../../public/images/carousel-swipe-left.svg';
import CarouselSwipeRightImage from '../../../public/images/carousel-swipe-right.svg';

const styles = theme => ({
  carousel: {
    [theme.breakpoints.only('xs')]:{
     /* maxWidth: '375px',*/
      width:'100%',
      height:'477px'
    },
    [theme.breakpoints.only('sm')]: {
      /*maxWidth: '790px',*/
      width:'100%',
      height:'364px'
    },
    [theme.breakpoints.up('lg')]: {
      /*maxWidth: '1200px'*/
      width:'100%'
    },
     [theme.breakpoints.up('md')]: {
      width:'100%'
       }
  }
});

class chatLandingCarousel extends Component {
  constructor(props) {
    super(props);

    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.detect = this.detect.bind(this);
    this.updateCurrentSlide = this.updateCurrentSlide.bind(this);
    this.generateLinkURL = this.generateLinkURL.bind(this);
    this.calculateAvailableSpace = this.calculateAvailableSpace.bind(this);
    this.getClassNames = this.getClassNames.bind(this);
    this.onLinkClicked = this.onLinkClicked.bind(this);

    this.rightArrowRef = React.createRef();
    this.leftArrowRef = React.createRef();
    this.emulateTouch=false;
    this.state={
      currentSlide:0,
      innerWidth: 0
    };

  }
  componentDidMount() {
    this.updateCurrentSlide(0);
    window.addEventListener('resize', this.detect);
  //  window.addEventListener('focus',this.focus);
    //window.addEventListener('blur',this.blur);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.detect);
   // window.removeEventListener("foucs", this.focus);
    //window.removeEventListener("blur", this.blur);
  }


  next(){
    this.setState({ currentSlide: this.state.currentSlide + 1 },()=>
    { });

  }

  prev(){
    this.setState({ currentSlide: this.state.currentSlide - 1 },()=>
    {});
  }

  focus=(event)=>
  {
    if(event.currentTarget.className=="imageContainer")
    {
      //console.log("the event originator is "+event.target);
      //console.log("tis a dot coming here now ***********");
      //console.log(event.currentTarget);
      //event.target.setAttribute('tabIndex','0');
      document.querySelectorAll('div.imageContainer').forEach((node,currentIndex) =>
      {
        console.log("the node is "+node.id);
        console.log("the event target is "+event.id);
        if(node.id==event.target.id)
        {
          console.log("there is a match  "+node.id);
        }

      });
    }


   /* if(event.currentTarget.getAttribute("class")=="dot selected")
    {
      console.log("the event originator is "+event.target);
      console.log("tis a dot coming here now ***********");
      console.log(event.currentTarget.css);;
    }*/
   //console.log("entering here on focus the active element now is "+document.activeElement);
    //var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    /*if(isChrome)
    console.log("on focus the active element now is "+document.activeElement);

    if(document.querySelector('li.dot')==document.activeElement)
    {
      console.log("on focus li.dot its the active element now");
      document.querySelector("ul.control-dots").setAttribute('aria-hidden','false');
    }
    else
    {
      console.log("on focus  li.dot its not the active element now");
      document.querySelector("ul.control-dots").setAttribute('aria-hidden', 'true');
    }*/
   /* if(document.querySelector('div.MuiGrid-root.image-container.MuiGrid-item.MuiGrid-grid-xs-true')==document.activeElement)
    {
      console.log("on focus div.imageContainer its the active element now");
    }*/

  }

  blur=(event)=>
  {

    console.log("coming to blur "+event.target);
    if(event.currentTarget.id=="Ask me anything")
    {

      document.querySelectorAll('li.dot').forEach((node,currentIndex) => {

        node.focus();

      });
      //event.currentTarget.removeAttribute('tabIndex');
      //console.log("the event originator is "+event.target);
      //console.log("tis a dot coming here now ***********");
      //console.log(event.currentTarget);
      //event.target.('tabIndex');
    }
    /*if(document.querySelector('div.MuiGrid-root.image-container.MuiGrid-item.MuiGrid-grid-xs-true')==document.activeElement)
    {
      console.log("on blur div.imageContainer its the active element now");
    }*/

  }

  detect()
  {
    //console.log(screen.orientation.angle);
    this.setState({innerWidth: window.innerWidth});
    if(this.state.innerWidth<=960)
    {
      this.emulateTouch=true;
    }
     else this.emulateTouch=false;

  }

  updateCurrentSlide(index)
  {

   //console.log("the index coming into updateCurrent Slide is "+index);

    // Firefox 1.0+
  //  var isFirefox = typeof InstallTrigger !== 'undefined';
   // var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    var isIE = !!navigator.userAgent.match(/Trident/g) ||!!navigator.userAgent.match(/Edge/g)|| !!navigator.userAgent.match(/MSIE/g);
    var isSafari=!!navigator.userAgent.match(/Safari/);
    var isSafariMobile=!!navigator.userAgent.match(/iPod|iPhone|iPad/);
    //var isSafari =isSafariMobile && webkit && !ua.match(/CriOS/i);

    if ((isChrome)&&(isSafari || isSafariMobile)) {isSafari=false;isSafariMobile=false;}


   // if(isFirefox) {
      //document.querySelector("ul.slider.animated").setAttribute('role', 'presentation');
      //document.querySelector("ul.slider.animated").setAttribute('tabIndex', '0');
      //document.querySelector("div.slider-wrapper.axis-horizontal").setAttribute('role','presentation');
      // document.querySelector("div.slider-wrapper.axis-horizontal").setAttribute('aria-hidden','true');


     //document.querySelector("ul.slider.animated").setAttribute('tabIndex','0');

     // document.querySelector("div.image-container").setAttribute('role','presentation');

    //  document.querySelector("div.carousel.carousel-slider").setAttribute('role','presentation');
    //  document.querySelector("div.carousel.carousel-slider").setAttribute('aria-hidden','true');
    //  document.querySelector("div.carousel.carousel-slider").setAttribute('tabIndex','0');

   // }

   // else if (isChrome) {
      /*document.querySelector("div.carousel.carousel-slider").setAttribute('role','presentation');
      document.querySelector("div.carousel.carousel-slider").setAttribute('aria-hidden','true');
      document.querySelector("div.carousel.carousel-slider").setAttribute('tabIndex','0');
      document.querySelector("div.carousel.carousel-slider").setAttribute('index',index);*/


      //if(document.querySelector("ul.slider.animated")!=null)
      // document.querySelector("ul.slider.animated").setAttribute('role', 'presentation');
       //document.querySelector("ul.slider.animated").setAttribute('tabIndex', '0');
     // document.querySelector("div .chatLanding-carousel-container .carousel .carousel-item").setAttribute('tabIndex', '0');

      //document.querySelector("div.slide.selected").setAttribute('role','presentation');
     // document.querySelector("div.image-container").setAttribute('tabIndex','0');

     // document.querySelector("div.slider-wrapper.axis-horizontal").setAttribute('role','presentation');
      //document.querySelector("div.slider-wrapper.axis-horizontal").setAttribute('tabIndex','0');

   // }



   /* document.querySelector("div.carousel.carousel-slider").setAttribute('role','presentation');
    document.querySelector("div.carousel.carousel-slider").setAttribute('aria-roledescription','');
    document.querySelector("div.carousel.carousel-slider").setAttribute('aria-hidden','true');
    document.querySelector("div.carousel.carousel-slider").setAttribute('tabIndex','0');*/

    if (document.querySelectorAll('li.dot')!=undefined && document.querySelector('li.dot')!=null) {
      if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }

      //document.querySelector("ul.control-dots").setAttribute('role','link');
      //document.querySelector("ul.control-dots").setAttribute('aria-hidden','true');
     // document.querySelector("ul.control-dots").setAttribute('tabIndex', '0');



      if (document.querySelector("div.carousel.carousel-slider") != null) {
        //if (document.querySelector('li.slide selected') != null) {

          //console.log(document.querySelector('li.slide.selected').lastElementChild.firstElementChild.lastChild.getAttribute('id'));
          if (document.querySelector('li.slide.selected').lastElementChild.firstElementChild.lastChild.getAttribute('id') === carouselConfig.carousel.SERVICE_PROBLEMS) {
            if(index===0) {
              if (document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex == '-1') {
                document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex = '0';
              }
            }

            if(index===2) {
              if (document.getElementById(carouselConfig.carousel.PODS).tabIndex == '-1') {
                document.getElementById(carouselConfig.carousel.PODS).tabIndex = '0';
              }

            }

            if (document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex == '0') {
              document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex = '-1';
            }

          }

          if( document.querySelector('li.slide.selected').lastElementChild.firstElementChild.lastChild.getAttribute('id')===carouselConfig.carousel.PAYMENT)
          {
            if(index===1) {
              if (document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex == '-1') {
                document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex = '0';
              }
            }
            if(index===2) {
              if (document.getElementById(carouselConfig.carousel.PODS).tabIndex == '-1') {
                document.getElementById(carouselConfig.carousel.PODS).tabIndex = '0';
              }

            }

            if (document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex == '0') {
              document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex = '-1';
            }
          }

        if( document.querySelector('li.slide.selected').lastElementChild.firstElementChild.lastChild.getAttribute('id')===carouselConfig.carousel.PODS)
        {
          if(index===1) {
            if (document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex == '-1') {
              document.getElementById(carouselConfig.carousel.SERVICE_PROBLEMS).tabIndex = '0';
            }
          }
          if(index===0) {
            if (document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex == '-1')
            {
              document.getElementById(carouselConfig.carousel.PAYMENT).tabIndex='0';
            }

          }

          if (document.getElementById(carouselConfig.carousel.PODS).tabIndex == '0') {
            document.getElementById(carouselConfig.carousel.PODS).tabIndex ='-1';
          }
        }



      }


      document.querySelectorAll('li.dot').forEach((node,currentIndex) => {


        node.setAttribute('aria-label', this.props.carousels[currentIndex].linkText);
         node.setAttribute('role','link');

        if(isSafari)
        {
         // console.log("isSafari is true *************");
          Object.assign(node.style,{ outline:'none',boxShadow: 'none'});
        }
       // node.setAttribute('aria-hidden','true');
        //node.setAttribute('tabIndex','0');
        node.addEventListener("focus",(event)=>{
         // console.log("the focus generator is "+event);

         // this.focus(event)
        });

         if(index==currentIndex) {


          // node.setAttribute('aria-hidden','false');
           node.setAttribute('tabIndex','0');

         }



       });

       }






      const {currentSlide} = this.state;

      if (currentSlide !== index) {
        this.setState({
          currentSlide: index
        });
      }

    }



    generateLinkURL() {
        return '/xfinityassistant/';
    }

calculateAvailableSpace(){
    //console.log("thw window Inner Width is "+window.innerWidth);
     /* if(window.innerWidth>=1024) {
        if (document.querySelector("div .divArrowLeftContainerStyle") != undefined && document.querySelector("div .divArrowRightContainerStyle") != undefined) {
         document.querySelector("div .divArrowRightContainerStyle").style.setProperty('--right', '3%');
          document.querySelector("div .divArrowLeftContainerStyle").style.setProperty('--left', '15%');
         }

        }

      else   (window.innerWidth<1024)
        {
          if (document.querySelector("div .divArrowLeftContainerStyle") != undefined && document.querySelector("div .divArrowRightContainerStyle") != undefined) {
            /!*if (this.rightArrowRef.style != null && this.refs.leftArrowRef.style != null) {*!/
            document.querySelector("div .divArrowRightContainerStyle").style.setProperty('--right', '15%');
            document.querySelector("div .divArrowLeftContainerStyle").style.setProperty('--left', '2%');
          }

        }*/

}

  getClassNames (type) {
    console.log('the type is now '+type.width);
    if(type.width=='xs') {

      return classNames('chatLanding-carousel-container', {
        ['extraSmallCarousel carousel-item']: type.width == 'xs'
      });
    }
    else if((type.width==='lg')||(type.width==='md')||(type.width==='xl'))
    {
      return classNames('chatLanding-carousel-container', {
        ['carousel carousel-item']: ((type.width === 'lg') ||(type.width === 'md')||(type.width==='xl'))
      });
    }
    else if(type.width==='sm')
    {
      return classNames('chatLanding-carousel-container', {
        ['smallCarousel carousel-item']: type.width === 'sm'
      });
    }

  }
    /*const {type} = this.props;

    return classNames('Button', {
      ['Button--big']: type === 'BIG',
      ['Button--disabled']: disabled,
      ['Button--hovered']: hovered,
    });*/
  //}

  renderImages(image,title,imgURL) {
    switch (image) {
      case "Restart":
        return (<div id={title}
                    aria-label="image"
                   /* onFocus={(event)=>{
          console.log('the event is '+event);
          this.focus(event)}}
      onBlur={(event)=>{this.blur(event)}}*/
                    tabIndex="-1"
                    className={'imageContainer'}><img  alt="" role="presentation" src={imgURL}/></div>);
      case "Payment":
        return (<div id={title}
                    aria-label="image"
                    //onFocus={(event)=>{
         // console.log('the event is '+event);
          //this.focus(event)}}
                    //onBlur={(event)=>{this.blur(event)}}
                    tabIndex="-1"
                    className={'imageContainer'}><img alt="" role="presentation"   src={imgURL}  /></div>);
      case "Pods":
        return (<div id={title}
                    aria-label="image"
                    //onFocus={(event)=>{
          //console.log('the event is '+event);
         // this.focus(event)}}
                   // onBlur={(event)=>{this.blur(event)}}
                    tabIndex="-1"
                    className={'imageContainer'}><img  alt="" role="presentation" src={imgURL}/></div>);
    }
  }


  hoverInImageRight(e) {
    if(document.querySelector("#rightArrowImage")!=null) {
      e.currentTarget.src = CarouselHoverRightImage;

    }
  }

  hoverOutImageRight(e) {
    if(document.querySelector("#rightArrowImage")!=null) {
      e.currentTarget.src = CarouselSwipeRightImage;


    }
  }

  hoverInImageLeft(e) {
    if(document.querySelector("#leftArrowImage")!=null) {
      e.currentTarget.src= CarouselHoverLeftImage;


    }
  }

  hoverOutImageLeft(e) {
    if(document.querySelector("#leftArrowImage")!=null) {
      e.currentTarget.src = CarouselSwipeLeftImage;
    }
  }




  render() {
    if(this.state.innerWidth<960) {this.emulateTouch=true;} else this.emulateTouch=false;
    const {classes,width} = this.props;
    return (<Grid container
                 direction="row"
                 justify="center"
                 alignItems="center"
                 className={'chatLanding-carousel-container'}>


      <Carousel
          selectedItem={this.state.currentSlide}
          onChange={this.updateCurrentSlide}
          emulateTouch={false}
          showThumbs={false}
          showStatus={false}
          showArrows={false}
          className={classes.carousel}
          autoPlay={false}>
        {this.props.carousels.map((carousel,index) =>


          <Grid container className={'carousel carousel-item'}
                key={carousel}
                item
                xs={12}
                direction="row"
                justify="center">

            <Hidden smDown>
              <Grid  item className={'image-container'}xs >
                {this.renderImages(carousel.img,carousel.title,carousel.imgURL)}
              </Grid>
            </Hidden>

            <Grid item md={6} sm={12} className={'details'} direction="column">
              <div aria-hidden="false" id={`${carousel.linkID}${index}`} className="title">
                {carousel.title}
              </div>
              <div aria-hidden="false"  id={`${carousel.linkID}${index}`} className="description">
                {carousel.description}
              </div>
              <Hidden smDown>
                <div  role="link" aria-hidden="false" aria-label= {carousel.linkText} id={`${carousel.linkID}${index}`} className="link">
                <Link aria-hidden="false" className="link" tabIndex="0" onKeyPress={(event)=>{this.handleKeyPress(event,this.generateLinkURL());}} onClick={(event)=>{this.onLinkClicked(event,this.generateLinkURL());}}> {carousel.linkText}</Link>
                </div>
              </Hidden>
              <Hidden mdUp>
                <div id={`${carousel.linkID}${index}`} className="link">
                  <Link aria-hidden="false" tabIndex="0" onKeyPress={(event)=>{this.handleKeyPress(event,this.generateLinkURL());}} onClick={(event)=>{this.onLinkClicked(event,this.generateLinkURL());}}> {carousel.linkText}</Link>
                </div>
              </Hidden>
            </Grid>
          </Grid>

        )}
      </Carousel>



      {<Grid item >
        <div ref={this.leftArrowRef} className={'divArrowLeftContainerStyle'}>
          <Grid item>
            <div  className="left-arrow"  onClick={this.goBack}>
               {isBrowser && this.state && this.state.currentSlide !== 0 &&
             <a data-tracking target="blank" role="link" tabIndex="0"> <img className={"leftArrowImage"} id="leftArrowImage" src={CarouselSwipeLeftImage} onClick={(event)=>{this.prev(event,this.state.currentSlide);}}
                                     onMouseOver={this.hoverInImageLeft}  onMouseOut={this.hoverOutImageLeft}/></a>
              }

            </div>
          </Grid>
        </div>
      </Grid>}
     {<Grid item >
        <div ref={this.rightArrowRef} className={'divArrowRightContainerStyle'}>
          <Grid item>
            <div   className="right-arrow" >
              {
                isBrowser && this.state && this.state.currentSlide !== this.props.carousels.length-1 &&
                <a data-tracking role="link" tabIndex="0" target="blank"><img className={"rightArrowImage"}  id="rightArrowImage"  src={CarouselSwipeRightImage} onClick={(event)=>{this.next(event,this.state.currentSlide);}}
                                       onMouseOver={this.hoverInImageRight} onMouseOut={this.hoverOutImageRight}/></a>
              }

            </div>
          </Grid>
        </div>
      </Grid>}
    </Grid>);
  }

  onLinkClicked(event,link)
  {
    this.props.defaultEvent( link,'Link');
    return false;
  }

  handleKeyPress(event, link) {
    if (event.key == 'Enter') {
      this.props.defaultEvent( link,'Link');
      return false;
    }
  }
}

export default compose(withStyles(styles), withWidth(),)(chatLandingCarousel);
